import Joi from '@hapi/joi'

export const DuplicateAttendanceReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().optional().allow(0).label("Division"),
    jobType: Joi.number().optional().allow(0).label("Job Type"),
    date: Joi.string().invalid("").required().label("Date").messages({
        "any.invalid": `Select Date`,
        "any.required": `Date required`
    })
}